package com.trevorwiebe.timesheet.core.presentation.common

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.unit.dp

/**
 * "Export file" icon (Material Symbols). The source SVG uses the Material Symbols
 * `0 -960 960 960` viewBox, so the path is wrapped in a group translated down by 960 to
 * map its coordinates into a standard top-left-origin viewport. The fill color is
 * irrelevant in practice since [androidx.compose.material3.Icon] tints the whole vector.
 */
val FileExportIcon: ImageVector by lazy {
    val pathData = PathParser().parsePathString(
        "M480-480ZM202-65l-56-57 118-118h-90v-80h226v226h-80v-89L202-65Zm278-15v-80h240" +
            "v-440H520v-200H240v400h-80v-400q0-33 23.5-56.5T240-880h320l240 240v480q0 33" +
            "-23.5 56.5T720-80H480Z"
    ).toNodes()

    ImageVector.Builder(
        name = "FileExport",
        defaultWidth = 24.dp,
        defaultHeight = 24.dp,
        viewportWidth = 960f,
        viewportHeight = 960f,
    ).apply {
        addGroup(translationY = 960f)
        addPath(pathData = pathData, fill = SolidColor(Color.Black))
        clearGroup()
    }.build()
}
